export default __webpack_public_path__ + "static/media/screenshot3_sm.add402a1.jpg";